module.exports = __webpack_public_path__ + "img/TUNE_STEEL.14c1f8f9.png";